import InputBase from '@material-ui/core/InputBase';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import withStyles from '@material-ui/core/styles/withStyles';
import Add from '@ori-ui/icons/lib/Add';
import Minus from '@ori-ui/icons/lib/Minus';
import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import BorderedIconButton from '../BorderedIconButton';
import useCounter from '../useCounter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const componentConfig = {
  name: 'MuiOriCounter'
};

const styles = theme => ({
  root: {
    display: 'inline-grid',
    gridTemplateColumns: '3rem 3.5rem 3rem',
    gridTemplateRows: '3rem',
    gridColumnGap: `${theme.spacing(1)}px`
  },
  input: {
    margin: 0,
    padding: 0,
    textAlign: 'center'
  },
  readOnly: {
    cursor: 'default'
  },
  iconButton: {}
});

export const Counter = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    classes,
    maxValue,
    minValue,
    disabled,
    className,
    editable,
    readOnly,
    required
  } = props;
  const {
    value,
    onDecrease,
    InputProps,
    onIncrease,
    handleChange
  } = useCounter(props);
  const InputComponent = useMemo(() => {
    if (editable) return OutlinedInput;
    return InputBase;
  }, [editable]);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(classes.root, className),
    children: [/*#__PURE__*/_jsx(BorderedIconButton, {
      type: "button",
      size: "small",
      disabled: disabled || value <= (minValue != null ? minValue : Number.NEGATIVE_INFINITY),
      "data-testid": "decrease",
      classes: {
        root: classes.iconButton
      },
      onClick: onDecrease,
      children: /*#__PURE__*/_jsx(Minus, {})
    }), /*#__PURE__*/_jsx(InputComponent, {
      inputRef: ref,
      classes: {
        input: clsx(classes.input, readOnly && classes.readOnly)
      },
      readOnly: readOnly,
      required: required,
      value: value,
      disabled: disabled,
      inputProps: {
        'data-testid': 'indicator'
      },
      onChange: handleChange,
      ...InputProps
    }), /*#__PURE__*/_jsx(BorderedIconButton, {
      type: "button",
      size: "small",
      disabled: disabled || value >= (maxValue != null ? maxValue : Number.POSITIVE_INFINITY),
      "data-testid": "increase",
      classes: {
        root: classes.iconButton
      },
      onClick: onIncrease,
      children: /*#__PURE__*/_jsx(Add, {})
    })]
  });
});
export default withStyles(styles, componentConfig)(Counter);